import React from 'react';
import { Route } from 'react-router-dom';

import { Module } from '../../utils';
import Home from './views/Home';

export default new Module({
  routes: [<Route exact path="/" component={Home} />]
});

export * from './components';